import axios from "axios";

const getProductTypesApi = async (id, page) => {
  const res = await axios.get(`/v1/website/subcategory-products/${id}?page=${page}`);
  return res.data;
};

export { getProductTypesApi };
